import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { ComingSoon } from "./pages/ComingSoon";
import { upcomingPages } from "./data/navigation";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3farfxtucjy5o">
      <Routes data-id="element-1" data-mp="3fa88j72bos5w">
        <Route element={<Layout data-id="element-3" data-mp="3fb9jzcn93go5" />} data-id="element-2" data-mp="3fbt1is8zo31n">
          <Route path="/" element={<Home data-id="element-5" data-mp="2rknkwav856qa" />} data-id="element-4" data-mp="3f8ndlgc3j77i" />
          {upcomingPages.map(page => <Route key={page.path} path={page.path} element={<ComingSoon page={page} data-id="element-7" data-mp="2mnnfm2678808" />} data-id="element-6" data-mp="2rit335f91uqf" />)}
          <Route path="*" element={<Home data-id="element-9" data-mp="31c9u61o04vqe" />} data-id="element-8" data-mp="31bs1tg4gn1nr" />
        </Route>
      </Routes>
    </BrowserRouter>;
}